// extracted by mini-css-extract-plugin
module.exports = {"withoutDialog":"T94su","withDialog":"Scsxu"};